import React, { ReactNode } from 'react';
import { Element } from './Sticky.styles';
import { VisibilityBreakpointType } from '@/styles/utilities';
import { DefaultTheme } from 'styled-components';

export interface StickyProps extends VisibilityBreakpointType {
  ref?: any;
  id?: string;
  top?: number;
  bottom?: number;
  zIndex?: number;
  children?: ReactNode;
  bgColor?: keyof DefaultTheme['color'];
}

const Sticky = React.forwardRef(function Sticky({ children, ...props }: StickyProps, ref) {
  return (
    <Element {...props} ref={ref}>
      {children}
    </Element>
  );
});

export default Sticky;
